export enum Colors {
  GreenDark = "#01BF60",
  GreenMedium = "#01DF70",
  GreenLight = "#35F587",

  BlueDark = "#3921D4",
  BlueMedium = "#554EFE",
  BlueLight = "#8391FF",

  RedDark = "#FE2F01",
  RedMedium = "#FF6542",
  RedLight = "#FF937B",

  YellowDark = "#FE9D01",
  YellowMedium = "#FFBE42",
  YellowLight = "#FFDB7B",

  GrayBlack = "#000000",
  GrayDarkest = "#343434",
  GrayDark = "#5A5A5A",
  GrayMedium = "#918C86",
  GrayLight = "#E4DFD9",
  GrayLightest = "#F6F5F3",
}
